import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/components/Auth/AuthLayout.css';

const AuthLayout = ({ 
  children, 
  welcomeContent, 
  showLanguageButton = false,
  onLanguageChange,
  currentLanguage,
  languageButtonText
}) => {
  const navigate = useNavigate();
  const [hexagonPositions, setHexagonPositions] = useState([]);

  // Generate random hexagon positions on component mount
  useEffect(() => {
    const generateRandomPositions = () => {
      const positions = [];
      for (let i = 0; i < 50; i++) {
        positions.push({
          top: Math.random() * 100, // Random top position (0-100%)
          left: Math.random() * 100, // Random left position (0-100%)
          delay: Math.random() * 2, // Random animation delay (0-2s)
          opacity: 0.03 + Math.random() * 0.05 // Random opacity (0.03-0.08)
        });
      }
      setHexagonPositions(positions);
    };

    generateRandomPositions();
  }, []);

  return (
    <div className="auth-main-container" style={{ 
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Hexagonal Background Pattern */}
      <div className="hexagonal-background">
        <div className="hex-grid">
          {hexagonPositions.map((pos, i) => (
            <div 
              key={i} 
              className="hexagon" 
              style={{
                top: `${pos.top}%`,
                left: `${pos.left}%`,
                animationDelay: `${pos.delay}s`,
                opacity: pos.opacity
              }}
            ></div>
          ))}
        </div>
      </div>

      {/* Left side - Welcome section */}
      <div className="auth-welcome-section">
        <div className="auth-logo-section">
          <div
            className="auth-logo-text"
            onClick={() => navigate('/')}
            role="link"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate('/');
              }
            }}
            title="Go to main page"
            style={{ cursor: 'pointer' }}
          >
            Oakland AI
          </div>
        </div>
        
        {welcomeContent}
      </div>

      {/* Right side - Auth section */}
      <div className="auth-form-section">
        <div className="auth-form-container">
          {/* Language Button */}
          {showLanguageButton && (
            <button 
              onClick={onLanguageChange}
              className="auth-language-button"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M2 12h20"/>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
              {languageButtonText || currentLanguage}
            </button>
          )}

          <div className="auth-form-content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout; 